var _path, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse, _ellipse2, _ellipse3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 24.4783L8 55.5217C8 57.4427 9.55727 59 11.4783 59H50.6112C51.5029 59 52.3604 58.6576 53.0069 58.0435L54 57.1L54.9931 58.0435C55.6396 58.6576 56.4972 59 57.3888 59H64.5217C66.4427 59 68 57.4427 68 55.5217V24.4783C68 22.5573 66.4427 21 64.5217 21H57.3888C56.4972 21 55.6396 21.3424 54.9931 21.9565L54 22.9L53.0069 21.9565C52.3604 21.3424 51.5028 21 50.6112 21L11.4783 21C9.55727 21 8 22.5573 8 24.4783Z",
    fill: "#3451D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23.125V56.875",
    stroke: "#1C339B",
    strokeWidth: 0.9375,
    strokeDasharray: "1.88 1.88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9176 36.0176H20.0078C19.6615 36.0176 19.3396 36.196 19.156 36.4897L17.1594 39.6843C17.0188 39.9092 16.9729 40.1806 17.0317 40.4392L19.0957 49.5208C19.3036 50.4355 20.1167 51.0845 21.0547 51.0845H40.9502C41.8882 51.0845 42.7013 50.4355 42.9092 49.5208L44.9732 40.4392C45.0319 40.1806 44.986 39.9092 44.8455 39.6843L42.8488 36.4897C42.6653 36.196 42.3434 36.0176 41.9971 36.0176H39.0873C38.7439 36.0176 38.4243 36.193 38.2399 36.4828L35.3163 41.0769C35.132 41.3667 34.8123 41.5421 34.4689 41.5421H27.536C27.1926 41.5421 26.8729 41.3667 26.6886 41.0769L23.765 36.4828C23.5806 36.193 23.261 36.0176 22.9176 36.0176Z",
    fill: "#FFCE51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2045 43.5322C23.3188 43.3232 23.619 43.3232 23.7333 43.5322L24.3144 44.5947C24.3421 44.6453 24.3836 44.6869 24.4342 44.7145L25.4967 45.2956C25.7057 45.4099 25.7057 45.7101 25.4967 45.8244L24.4342 46.4055C24.3836 46.4331 24.3421 46.4747 24.3144 46.5253L23.7333 47.5877C23.619 47.7967 23.3188 47.7967 23.2045 47.5877L22.6234 46.5253C22.5958 46.4747 22.5542 46.4331 22.5037 46.4055L21.4412 45.8244C21.2322 45.7101 21.2322 45.4099 21.4412 45.2956L22.5037 44.7145C22.5542 44.6869 22.5958 44.6453 22.6234 44.5947L23.2045 43.5322Z",
    fill: "#3451D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2714 43.5322C38.3857 43.3232 38.6859 43.3232 38.8002 43.5322L39.3813 44.5947C39.409 44.6453 39.4505 44.6869 39.5011 44.7145L40.5636 45.2956C40.7726 45.4099 40.7726 45.7101 40.5636 45.8244L39.5011 46.4055C39.4505 46.4331 39.409 46.4747 39.3813 46.5253L38.8002 47.5877C38.6859 47.7967 38.3857 47.7967 38.2714 47.5877L37.6903 46.5253C37.6627 46.4747 37.6211 46.4331 37.5706 46.4055L36.5081 45.8244C36.2991 45.7101 36.2991 45.4099 36.5081 45.2956L37.5706 44.7145C37.6211 44.6869 37.6627 44.6453 37.6903 44.5947L38.2714 43.5322Z",
    fill: "#3451D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.738 28.4648C30.8523 28.2559 31.1524 28.2559 31.2668 28.4648L33.0908 31.8C33.1185 31.8506 33.16 31.8921 33.2106 31.9198L36.5458 33.7438C36.7547 33.8582 36.7547 34.1583 36.5458 34.2726L33.2106 36.0967C33.16 36.1243 33.1185 36.1659 33.0908 36.2165L31.2668 39.5516C31.1525 39.7606 30.8523 39.7606 30.738 39.5516L28.9139 36.2165C28.8863 36.1659 28.8447 36.1243 28.7941 36.0967L25.459 34.2726C25.25 34.1583 25.25 33.8582 25.459 33.7438L28.7941 31.9198C28.8447 31.8921 28.8863 31.8506 28.9139 31.8L30.738 28.4648Z",
    fill: "#FFCE51"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.001 62C52.001 56.4771 56.4781 52 62.001 52C67.5238 52 72.001 56.4771 72.001 62C72.001 67.5228 67.5238 71.9999 62.001 71.9999C60.2078 71.9999 58.5226 71.5271 57.0658 70.6991L52.9838 71.7475C52.5418 71.861 52.1399 71.4591 52.2534 71.0171L53.3018 66.9351C52.4738 65.4784 52.001 63.7931 52.001 62Z",
    fill: "#8A9DF1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58,
    cy: 62,
    rx: 1,
    ry: 0.999997,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.001,
    cy: 62,
    rx: 1,
    ry: 0.999997,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 66,
    cy: 62,
    rx: 1,
    ry: 0.999997,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumService);
export default __webpack_public_path__ + "static/media/premium-service.fee9c4a6454afa04e36f053525b71bbd.svg";
export { ForwardRef as ReactComponent };